import request from '@/utils/request'

// 创建商户
export const addMerchant = (data: any) =>
  request({
    url: '/manage/merchant',
    method: 'post',
    data
  })

// 删除商户
export const delMerchant = (data: any) =>
  request({
    url: '/manage/merchant/' + data.id,
    method: 'delete',
    data
  })

// 编辑商户(商户名，手机号，备注，状态，回调地址，重定向地址，IP白名单)
export const setMerchant = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no,
    method: 'patch',
    data
  })

// 绑定上级商户
export const setAncestor = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/ancestor',
    method: 'put',
    data
  })

// 查找商户
export const getMerchant = (params: any) =>
  request({
    url: '/manage/merchant',
    method: 'get',
    params
  })

// 变更商户邮箱
export const setMerchantEmail = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/change-email',
    method: 'put',
    data
  })

// 变更商户密码
export const setMerchantPsw = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/change-password',
    method: 'put',
    data
  })

// 变更商户提现码
export const setMerchantPin = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/change-pin',
    method: 'put',
    data
  })

// 重置key
export const setChangeKey = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/change-key',
    method: 'put',
    data
  })

// 变更商户 Google 验证
export const setGoogleStatus = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/change-google-auth',
    method: 'put',
    data
  })

// 获取商户登录日志列表
export const getloginLog = (params: any) =>
  request({
    url: '/manage/merchant/' + params.merchant_no + '/manager-login-log',
    method: 'get',
    params
  })

// 跳转商户后台
export const jumpMerchantPlatform = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/jump',
    method: 'post',
    data
  })
